export const environment = {
  production: true,
  buildId: '2825737050219411',
  configFile: 'config.json',
};
